import React, { useContext, useRef } from "react";
import type { FC, PropsWithChildren } from "react";

import { Context } from "./context";

import type { InputTextAreaProps } from "../types";

interface IOptions extends Pick<InputTextAreaProps, "maxLines" | "maxHeight"> {}

export const useInputTextAreaStore = (options: IOptions) => {
    /** Ссылка на textarea (InputTextArea.Input) */
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    return {
        ...options,
        textAreaRef,
    };
};

export const useStore = () => useContext(Context);

interface IInputTextAreaProvider {
    options: IOptions;
}

export const InputTextAreaProvider: FC<
    PropsWithChildren<IInputTextAreaProvider>
> = ({ children, options }) => {
    const store = useInputTextAreaStore(options);

    // eslint-disable-next-line ok-custom-rules/check-attribute
    return <Context.Provider value={store}>{children}</Context.Provider>;
};
